<template>
  <div class="add-provider">
    <div class="card mg-b-10 pd-40">
      <div
        class="card-header mg-b-40 d-sm-flex align-items-start justify-content-start bd-b-0 pd-b-0"
      >
        <div class="table-title-icon">
          <div class="f-left txt-box">
            <div class="mg-b-5 fx-h5">Role</div>
            <p class="tx-13 tx-color-03 mg-b-0">Add Role</p>
          </div>
        </div>
      </div>
      <div class="card-body">
        <!-- <slot name="form"></slot> -->
        <CustomForm
          :pages="Role.wizard.pages"
          :action="Role.wizard.action"
          :buttonText="Role.wizard.actionBtn"
          :showTitle="false"
        ></CustomForm>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.Role = Models.Role;

    Event.$on("form:submit", async (payload) => {
      this.addRole(payload.formData)
    });
  },
  data() {
    return {
      Role: {},
      Roles: [],
    };
  },
  methods: {
      async addRole(data) {
        try {
            let res = await req.callServerSecure({
            resource: "role",
            action: "add",
            data: {
                name: data.name,
                description: data.description,
                inst_code: "ABC",
                role_code: data.code
            },
            meta_data: {},
            });
                   this.$router.push({
                        name: "list_roles",
                        params: {}
                    });

        } catch (err) {
            console.log("err", err);
        }

      }
  },
  async mounted() {
    Event.$emit("loader:show", false);
  },
};
</script>

<style>
</style>